import {
    PostAPI,
    PostAPIWithoutRequest,
    PostAPIWithoutRequestAndKeyData,
  } from "src/components/api/helper/apiHelper";

export const GoogleLogin = async (request: any) => {
  return PostAPI(request, 'Credential/GoogleLogin');
};